import React from 'react';
import { Text, TouchableOpacity, Linking } from 'react-native';
import LinkifyIt from 'linkify-it';

const linkify = new LinkifyIt();
const hashtagRegex = /#[^\s#]+/g;
const handleRegex = /@[a-zA-Z0-9.-]+/g;

type Props = {
  children: React.ReactNode;
  style?: any;
  linkStyle?: any;
  linkDefault?: boolean;
  onHashtagPress?: (hashtag: string) => void;
  onHandlePress?: (handle: string) => void;
  selectable?: boolean;
};

export default function Hyperlink({ children, style, linkStyle, linkDefault, onHashtagPress, onHandlePress, selectable }: Props) {
  const text = typeof children === 'string' ? children : (Array.isArray(children) ? children.join('') : String(children));
  const matches = linkify.match(text) || [];
  
  const hashtagMatches: any[] = [];
  let hMatch;
  const hRegex = /#[^\s#]+/g;
  while ((hMatch = hRegex.exec(text)) !== null) {
    hashtagMatches.push({
      index: hMatch.index,
      lastIndex: hRegex.lastIndex,
      text: hMatch[0],
      url: hMatch[0],
      isHashtag: true
    });
  }

  const handleMatches: any[] = [];
  let atMatch;
  const atRegex = /@[a-zA-Z0-9.-]+/g;
  while ((atMatch = atRegex.exec(text)) !== null) {
    handleMatches.push({
      index: atMatch.index,
      lastIndex: atRegex.lastIndex,
      text: atMatch[0],
      url: atMatch[0],
      isHandle: true
    });
  }

  const allMatches = [...matches, ...hashtagMatches, ...handleMatches].sort((a, b) => a.index - b.index);
  const filteredMatches: any[] = [];
  let currentEnd = 0;
  allMatches.forEach(m => {
    if (m.index >= currentEnd) {
      filteredMatches.push(m);
      currentEnd = m.lastIndex;
    }
  });

  if (filteredMatches.length === 0) return <Text style={style} selectable={selectable}>{text}</Text>;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  filteredMatches.forEach((m, i) => {
    const start = m.index;
    const end = m.lastIndex;
    if (start > lastIndex) parts.push(<Text key={`t-${i}`} style={style} selectable={selectable}>{text.slice(lastIndex, start)}</Text>);
    
    const onPress = () => {
      if (m.isHashtag) {
        if (onHashtagPress) onHashtagPress(m.text);
      } else if (m.isHandle) {
        if (onHandlePress) onHandlePress(m.text);
      } else if (linkDefault) {
        Linking.openURL(m.url);
      }
    };

    parts.push(
      <Text key={`a-${i}`} style={[style, linkStyle]} onPress={onPress} selectable={selectable}>
        {m.text || m.url}
      </Text>
    );
    lastIndex = end;
  });
  if (lastIndex < text.length) parts.push(<Text key="t-last" style={style} selectable={selectable}>{text.slice(lastIndex)}</Text>);

  return <Text style={style} selectable={selectable}>{parts}</Text>;
}
